<div class="flex flex-col w-full">
    <!-- Header Top (logo, search, avatar) -->
    <div class="flex flex-row sm:justify-center h-[52px] p-2 pl-6 pr-6 gap-2 sm:gap-12 items-center">
        <a class="flex flex-row items-center gap-2 sm:w-20 hover:cursor-pointer" href="/">
            <img src="https://images.pondertcg.com/site/PonderIconColorizedAlt.svg" width="24" height="24" class="size-6">
            <p class="hidden sm:block font-title font-bold">Ponder</p>
        </a>
        <primary-search class="content-center grow sm:grow-0"></primary-search>
        <div class="invisible sm:visible vertical-separator-small"></div>
        <header-tools></header-tools>
    </div>
    <!-- Navigation Bar -->
    <div class="flex flex-col md:flex-row bg-ponder-light align-middle text-sm p-1 pl-1 sm:pl-3 pr-3 md:gap-3" [ngClass]="{ 'hidden' : !showNavbar }">
        <div class="hidden md:block w-[5%]"></div>
        <navbar [minSegments]="3"></navbar>
        <filter-bar class="flex flex-row grow"></filter-bar>
    </div>
    <!-- Notifications -->
    <global-notifications></global-notifications>
</div>